import { lazy, Suspense, useEffect, useState, type ReactNode } from 'react';
import { CardLoadingSpinner } from '@/components/ui/loading-spinner';

const InteractiveBackGesture = lazy(() =>
  import('@/components/interactive-back-gesture').then((module) => ({
    default: module.InteractiveBackGesture,
  })),
);

const MOBILE_POINTER_QUERY = '(hover: none) and (pointer: coarse)';

export function InteractiveBackGestureLoader({ children }: { children: ReactNode }) {
  const [shouldLoadGesture, setShouldLoadGesture] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(MOBILE_POINTER_QUERY).matches,
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia(MOBILE_POINTER_QUERY);
    const update = () => setShouldLoadGesture(mediaQuery.matches);

    update();
    mediaQuery.addEventListener('change', update);
    return () => mediaQuery.removeEventListener('change', update);
  }, []);

  if (!shouldLoadGesture) return <>{children}</>;

  return (
    <Suspense fallback={
      <div className="flex flex-1 items-center justify-center" role="status">
        <CardLoadingSpinner />
      </div>
    }>
      <InteractiveBackGesture>{children}</InteractiveBackGesture>
    </Suspense>
  );
}
